import { useState } from "react";

interface SharePanelProps {
  title: string;
  url?: string;
}

const PLATFORMS = [
  { key: "微博", icon: "ri-weibo-fill", color: "text-accent-600" },
  { key: "微信", icon: "ri-wechat-fill", color: "text-primary-600" },
  { key: "QQ", icon: "ri-qq-fill", color: "text-secondary-600" },
  { key: "复制链接", icon: "ri-link", color: "text-foreground-700" }
];

export default function SharePanel({ title, url }: SharePanelProps) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");

  const handleShare = (key: string) => {
    if (key === "复制链接") {
      const link = url || window.location.href;
      navigator.clipboard?.writeText(link).catch(() => undefined);
      setToast("链接已复制（演示功能，未真实分享）");
    } else {
      setToast(`已唤起「${key}」分享面板（演示功能，未真实发布）`);
    }
    window.setTimeout(() => setToast(""), 2200);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
      >
        <i className="ri-share-forward-line"></i>
        分享
      </button>

      {open && (
        <div className="fixed inset-0 z-[60] flex items-end justify-center bg-background-950/50 p-0 sm:items-center sm:p-4" onClick={() => setOpen(false)}>
          <div
            className="w-full max-w-sm rounded-t-2xl bg-background-50 p-6 sm:rounded-2xl"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-foreground-950">分享这篇内容</h3>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="关闭分享面板"
                className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <p className="mt-1 truncate text-sm text-foreground-500">{title}</p>

            <div className="mt-5 grid grid-cols-4 gap-3">
              {PLATFORMS.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => handleShare(item.key)}
                  className="flex cursor-pointer flex-col items-center gap-2 rounded-lg py-2 transition-colors hover:bg-background-100"
                >
                  <span className={`flex h-11 w-11 items-center justify-center rounded-full bg-background-100 ${item.color}`}>
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="text-xs text-foreground-600">{item.key}</span>
                </button>
              ))}
            </div>

            <p className="mt-5 rounded-lg bg-accent-50 px-3 py-2.5 text-xs leading-relaxed text-accent-800">
              <i className="ri-information-line mr-1"></i>
              演示说明：分享为前端模拟交互，不会向任何平台真实发布内容。
            </p>

            {toast && (
              <p className="mt-3 rounded-lg bg-primary-50 px-3 py-2.5 text-xs text-primary-700">{toast}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
}